export const tableHeader = [
  'Test Name',
  'Questions',
  'Duration',
  'Published On'
]
